<div id="otp-verification-container">
    <div id="otp-verification-form-container">
        <!-- PIAS Logo -->
        <p>
            <img src="assets/images/PIAS-logo.png" alt="PIAS-logo" id="pias-logo" class="img img-fluid" />
        </p>

        <div class="card">
            <div class="card-body">
                <p class="card-title mb-4 h4 fw-bold">OTP Verification</p>

                <!-- OTP Verification Form -->
                <form class="w-100" [formGroup]="otpVerifyFg">
                    <p class="w-100">
                        <mat-form-field class="w-100" [hideRequiredMarker]="true">
                            <mat-label>OTP</mat-label>
                            <input matInput type="text" maxlength="6" formControlName="otpCode" required />
                            @if(this.otpVerifyFg.controls["otpCode"].invalid
                            && (this.otpVerifyFg.controls["otpCode"].touched ||
                            this.otpVerifyFg.controls["otpCode"].dirty)
                            ) {
                            <mat-error>
                                @if(this.otpVerifyFg.controls["otpCode"].errors?.["required"]) {
                                <span>Required field.</span>
                                }
                                @else {
                                <span></span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </p>
                    <p class="w-100">
                        <a class="pias-link d-flex align-items-middle justify-content-center"
                            (click)="this.requestOtpEmail()">
                            <mat-icon class="me-1">refresh</mat-icon>
                            Resend code
                        </a>
                    </p>
                    <p class="w-100">
                        <button type="submit" class="btn-pias" [disabled]="this.otpVerifyFg.invalid || this.isVerifyOtpLoading()"
                            (click)="this.otpVerification()">
                        
                            @if(this.isVerifyOtpLoading()) {
                            <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
                            <span class="ms-1 fw-normal" role="status">Loading...</span>
                            }
                            @else {
                                <span>Verify</span>
                            }
                        </button>
                    </p>
                </form>
            </div>
        </div>

        <!-- Footer -->
        <div id="pias-footer">
            <p>© 2025 Professional Investment Advisory Services Pte Ltd</p>
        </div>
    </div>
</div>